// VH-285: the Security page's overview query key.
export const SECURITY_QUERY_KEY = ['auth', 'security']
